export const SOURCE_SKILL_DESCRIPTIONS = Object.freeze({
    'ВД': 'водитель автомобиля',
    'КТ': 'машинист колта-заливщика',
    'НР': 'нарезчик',
    'ОТ': 'отделочник',
    'БК': 'водитель бобкета',
    'ТР': 'тракторист',
    'СВ': 'сварщик',
    'ДР': 'дорожный рабочий'
});

export function sourceSkillDescription(name) {
    const code = String(name || '').trim().toLocaleUpperCase('ru-RU');
    return SOURCE_SKILL_DESCRIPTIONS[code] || null;
}
